import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Navbar from '../components/Navbar'
import Item from '../components/ProductCard'
import axios from 'axios'
import ld from '../images/load.gif'
import styles from '../styles/home.module.css'

function Home() {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  const getproducts = async () => {
    try {
      setLoading(true)
      const res = await axios.get("https://pro-shop-backend.vercel.app/api/products")
      if (res.data.success) {
        setProducts(res.data.message)
      } else {
        toast.error(res.data.message || 'Failed to fetch products', {
          position: 'bottom-right',
          theme: 'colored'
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      const errorMessage = error.response?.data?.message || 'Failed to fetch products. Please try again.'
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      })
    }
  }

  useEffect(() => {
    getproducts()
  }, [])

  return (
    <div className={styles.home}>
      <Navbar />
      <h3 className={styles.latProd}>Our Latest Products</h3>

      {loading ? (
        <div className={styles.loadingContainer}>
          <img src={ld} className={styles.loaderImage} alt="loader" />
        </div>
      ) : products && products.length > 0 ? (
        <div className={styles.products}>
          {products.map((elem, i) => {
            return <Item key={i} data={elem} />
          })}
        </div>
      ) : (
        <div className={styles.noProducts}>
          <p>No products available at the moment.</p>
        </div>
      )}

      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

export default Home